import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadBillingItemsSuccess(billingItems) {
  return { type: types.LOAD_BILLING_ITEMS_SUCCESS, billingItems };
}

export function createBillingItemSuccess(billingItem) {
  return { type: types.CREATE_BILLING_ITEM_SUCCESS, billingItem };
}

export function updateBillingItemSuccess(billingItem) {
  return { type: types.UPDATE_BILLING_ITEM_SUCCESS, billingItem };
}

export function deleteBillingItemSuccess(billingItem) {
  return { type: types.DELETE_BILLING_ITEM_SUCCESS, billingItem };
}

export function loadBillingItemsForEntry(entryId) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'repair-log-entries/' + entryId + '/billing-items';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadBillingItemsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveBillingItem(billingItem) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'billing-items';
    if (billingItem.id) {
      url = baseApi + 'billing-items/' + billingItem.id;
      return axios
        .put(url, {
          ...billingItem,
        })
        .then((response) => {
          dispatch(updateBillingItemSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          logEntryId: billingItem.logEntryId,
          itemName: billingItem.itemName,
          itemDesc: billingItem.itemDesc,
          itemQty: billingItem.itemQty,
          pricePerQty: billingItem.pricePerQty,
        })
        .then((response) => {
          dispatch(createBillingItemSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteBillingItem(id) {
  return function (dispatch) {
    let url = baseApi + 'billing-items/' + id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteBillingItemSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/billingItemActions.js